/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEaseInOut = createReactComponent("ease-in-out", "IconEaseInOut", [
  ["path", { d: "M3 20c8 0 10 -16 18 -16", key: "svg-0" }]
]);

export { IconEaseInOut as default };
//# sourceMappingURL=IconEaseInOut.js.map
